module.exports = __webpack_public_path__ + "8206ed8c85e5703c440b9ed9d3a78fc1.png";